import { getDownloadUrl } from "../lib/media";

export type EvtccExam = {
  code: string;
  title: string;
  description: string;
  files: {
    title: string;
    url: string;
  }[];
};

export type EvtccExamCategory = {
  title: string;
  exams: EvtccExam[];
};


export const evtccTestCategories: EvtccExamCategory[] = [
  {
    title: "Fire Apparatus Technician Exams",
    exams: [
      {
        code: "F1",
        title: "Maintenance, Inspection, and Testing of Fire Apparatus",
        description: "F1 covers the maintenance, inspection, and testing of fire apparatus as described in NFPA 1910: Standard for the Inspection, Maintenance, Refurbishment, Testing and Retirement of In-Service Emergency Vehicles and Marine Firefighting Vessels (NFPA 1911 Chapters).",
        files: [
          {
            title: "F1 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/F1-Ref.pdf")
          },
          {
            title: "F1 Sample Questions",
            url: getDownloadUrl("tests/F1-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "F2",
        title: "Design and Performance Standards of Fire Apparatus",
        description: "F2 covers the standards for fire apparatus as described in NFPA 1900: Standard for Aircraft Rescue and Firefighting Vehicles, Automotive Fire Apparatus, Wildland Fire Apparatus, and Automotive Ambulances (NFPA 1901 Chapters).",
        files: [
          {
            title: "F2 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/F2-Ref.pdf")
          },
          {
            title: "F2 Sample Questions",
            url: getDownloadUrl("tests/F2-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "F3",
        title: "Fire Pumps and Accessories",
        description: "F3 covers the standards as described in NFPA 1900: Standard for Aircraft Rescue and Firefighting Vehicles, Automotive Fire Apparatus, Wildland Fire Apparatus, and Automotive Ambulances (NFPA 1901 Chapters) and NFPA 1910: Standard for the Inspection, Maintenance, Refurbishment, Testing and Retirement of In- Service Emergency Vehicles and Marine Firefighting Vessels(NFPA 1911 Chapters).Please note that this test draws from the 2024 editions.",
        files: [
          {
            title: "F3 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/F3-Ref.pdf")
          },
          {
            title: "F3 Sample Questions",
            url: getDownloadUrl("tests/F3-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "F4",
        title: "Fire Apparatus Electrical Systems",
        description: "F4 covers the basic design and performance requirements of fire apparatus electrical systems, components of electrical systems, and preventive maintenance and troubleshooting activities.",
        files: [
          {
            title: "F4 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/F4-Ref.pdf")
          },
          {
            title: "F4 Sample Questions",
            url: getDownloadUrl("tests/F4-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "F5",
        title: "Aerial Fire Apparatus",
        description: "F5 covers the standards as described in NFPA 1900: Standard for Aircraft Rescue and Firefighting Vehicles, Automotive Fire Apparatus, Wildland Fire Apparatus, and Automotive Ambulances (NFPA 1901 Chapters) and NFPA 1910: Standard for the Inspection, Maintenance, Refurbishment, Testing and Retirement of In - Service Emergency Vehicles and Marine Firefighting Vessels(NFPA 1911 Chapters).Please note that this test draws from the 2024 editions.",
        files: [
          {
            title: "F5 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/F5-Ref.pdf")
          },
          {
            title: "F5 Sample Questions",
            url: getDownloadUrl("tests/F5-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "F6",
        title: "Allison Automatic Transmissions",
        description: "F6 covers the servicing and maintenance, diagnostics and troubleshooting of Allison Automatic Transmissions 3000/4000 Series, 1000/2000 Series & HT series (Fire Truck Pump mode only).",
        files: [
          {
            title: "F6 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/F6-Ref.pdf")
          },
          {
            title: "F6 Sample Questions",
            url: getDownloadUrl("tests/F6-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "FA4",
        title: "Advanced Electrical Systems",
        description: "FA4 covers advanced electrical systems, including load managers, strobe systems, digital controls, multiplexing, and line voltage generating systems of emergency vehicles.",
        files: [
          {
            title: "FA4 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/FA4-Ref.pdf")
          },
          {
            title: "FA4 Sample Questions",
            url: getDownloadUrl("tests/FA4-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "F7",
        title: "Fire Apparatus Foam Systems",
        description: "",
        files: [
          {
            title: "F7 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/F7-Ref.pdf")
          },
          {
            title: "F7 Sample Questions",
            url: getDownloadUrl("tests/F7-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "F8",
        title: "Fire Apparatus Hydraulic Systems",
        description: "",
        files: [
          {
            title: "F8 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/F8-Ref.pdf")
          },
          {
            title: "F8 Sample Questions",
            url: getDownloadUrl("tests/F8-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "GL",
        title: "Ground Ladder Testing",
        description: "GL tests knowledge of testing, maintenance and operation of ground ladders. The exam uses NFPA 1931: Standard for Manufacturers’ Design of Fire Department Ground Ladders and NFPA: 1932 Standard on Use, Mainteance, and Service Testing of In-Service Fire Department Ground Ladders.",
        files: [
          {
            title: "GL Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/GL-Ref.pdf")
          },
          {
            title: "GL Sample Questions",
            url: getDownloadUrl("tests/GL-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "DO1",
        title: "Driver Operator Inspection",
        description: "DO1 tests the knowledge of the Driver Operator to do a daily/weekly check that will satisfy the new requirements of NFPA 1910: Standard for the Inspection, Maintenance, Refurbishment, Testing and Retirement of In-Service Emergency Vehicles and Marine Firefighting Vessels (NFPA 1911 Chapters.) It is designed to be done without the use of a creeper and should be able to be completed in approximately one hour or less.",
        files: [
          {
            title: "DO1 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/DO1-Ref.pdf")
          },
          {
            title: "DO1 Sample Questions",
            url: getDownloadUrl("tests/DO1-SampleQuestions.pdf")
          }
        ],
      },
    ],
  },
  {
    title: "Ambulance Technician Exams",
    exams: [
      {
        code: "E0",
        title: "Maintenance, Inspection, and Testing of Ambulances",
        description: "E0 covers the maintenance, inspection, and testing of ambulances as covered in Meritor Preventive Maintenance and Lubrication, and NFPA 1910: Standard for the Inspection, Maintenance, Refurbishment, Testing and Retirement of In-Service Emergency Vehicles and Marine Firefighting Vessels (NFPA 1911 Chapters).",
        files: [
          {
            title: "E0 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/E0-Ref.pdf")
          },
          {
            title: "E0 Sample Questions",
            url: getDownloadUrl("tests/E0-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "E1",
        title: "Design & Performance Standards of Ambulances",
        description: "E1 covers the general design and performance standards for ambulances as described in NFPA 1900: Standard for Aircraft Rescue and Firefighting Vehicles, Automotive Fire Apparatus, Wildland Fire Apparatus, and Automotive Ambulances (NFPA 1917 Chapters).",
        files: [
          {
            title: "E1 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/E1-Ref.pdf")
          },
          {
            title: "E1 Sample Questions",
            url: getDownloadUrl("tests/E1-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "E2",
        title: "Ambulance Electrical Systems",
        description: "E2 covers the basic design and performance requirements of ambulance electrical systems, components of electrical systems, and preventive maintenance and troubleshooting activities.",
        files: [
          {
            title: "E2 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/E2-Ref.pdf")
          },
          {
            title: "E2 Sample Questions",
            url: getDownloadUrl("tests/E2-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "E3",
        title: "Ambulance Heating, Air-Conditioning, and Ventilation Systems",
        description: "E3 covers basic design, requirements and components of ambulance HVAC systems.",
        files: [
          {
            title: "E3 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/E3-Ref.pdf")
          },
          {
            title: "E3 Sample Questions",
            url: getDownloadUrl("tests/E3-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "E4",
        title: "Ambulance Cab, Chassis, and Powertrain",
        description: "E4 covers the requirements for the systems that are unique to ambulances, as well as common chassis components.",
        files: [
          {
            title: "E4 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/E4-Ref.pdf")
          },
          {
            title: "E4 Sample Questions",
            url: getDownloadUrl("tests/E4-SampleQuestions.pdf")
          }
        ],
      },
    ]
  },
  {
    title: "ARFF Technician Exams",
    exams: [
      {
        code: "A1",
        title: "Design & Performance Standards and Preventive Maintenance of Aircraft Rescue and Fire-Fighting Vehicles",
        description: "A1 covers the general design and performance standards for ARFF vehicles as described in FAA Advisory Circular 10c Guide Specifications for Water/Foam Aircraft Rescue and Fire-Fighting Vehicles, and the general principles of preventive maintenance and servicing.",
        files: [
          {
            title: "A1 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/A1-Ref.pdf")
          },
          {
            title: "A1 Sample Questions",
            url: getDownloadUrl("tests/A1-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "A2",
        title: "Chassis and Vehicle Components of Aircraft Rescue and Fire-Fighting Vehicles",
        description: "A2 covers the operation and testing of the chassis and vehicle components of ARFF vehicles, the operation of the vehicle systems and components, and inspections, maintenance, and repair of those components.",
        files: [
          {
            title: "A2 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/A2-Ref.pdf")
          },
          {
            title: "A2 Sample Questions",
            url: getDownloadUrl("tests/A2-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "A3",
        title: "Extinguishment Systems of Aircraft Rescue and Fire-Fighting Vehicles",
        description: "A3 covers basic design requirements and components of ARFF vehicle extinguishment systems.",
        files: [
          {
            title: "A3 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/A3-Ref.pdf")
          },
          {
            title: "A3 Sample Questions",
            url: getDownloadUrl("tests/A3-SampleQuestions.pdf")
          }
        ],
      },
    ]
  },
  {
    title: "LEV Technician Exams",
    exams: [
      {
        code: "L1",
        title: "Law Enforcement Vehicle Installation",
        description: "L1 covers design and performance standards, installation of specialized systems and equipment, and the accepted practices of upfitting Law Enforcement Vehicles. This exam is available in Spanish. Call the EVTCC office at 847-426-4075 for info on how to register for the Spanish version.",
        files: [
          {
            title: "L1 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/L1-Ref.pdf")
          },
          {
            title: "L1 Sample Questions",
            url: getDownloadUrl("tests/L1-SampleQuestions.pdf")
          },
          {
            title: "L1 Prep Guide",
            url: getDownloadUrl("tests/L1-PrepGuide.pdf")
          }
        ],
      },
    ]
  },
  {
    title: "Management Exams",
    exams: [
      {
        code: "M1",
        title: "Management Level 1",
        description: "M1 is based on the principles published by the Association of Equipment Management Professionals (AEMP) in The Career Equipment Fleet Manager. Reference publication ordering information to prepare for the Management Exam is listed at the top of the page of the exam’s learning objectives.",
        files: [
          {
            title: "M1 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/M1-Ref.pdf")
          },
          {
            title: "M1 Sample Questions",
            url: getDownloadUrl("tests/M1-SampleQuestions.pdf")
          }
        ],
      },
      {
        code: "M2",
        title: "Management Level 2",
        description: "M2 is based on the principles published by the Association of Equipment Management Professionals (AEMP) in The Career Equipment Fleet Manager. Reference publication ordering information to prepare for the Management Exam is listed at the top of the page of the exam’s learning objectives.",
        files: [
          {
            title: "M2 Reference Materials and Learning Objectives",
            url: getDownloadUrl("tests/M2-Ref.pdf")
          },
          {
            title: "M2 Sample Questions",
            url: getDownloadUrl("tests/M2-SampleQuestions.pdf")
          }
        ],
      }
    ]
  }
];

export const evtccExams = evtccTestCategories.flatMap((cat) => cat.exams);

export const evtccExamsMap = new Map<string, EvtccExam>(
  evtccExams.map((exam) => [exam.code, exam])
);